import { FC, useEffect, useState } from 'react'

interface LoaderProps {
    text: string
    className?: string
    visible?: boolean
}

const Loader: FC<LoaderProps> = ({ text, className = '', visible }) => {
    const controlled = visible !== undefined
    const [shouldRender, setShouldRender] = useState(controlled ? visible : true)
    const [animating, setAnimating] = useState(controlled ? visible : true)

    useEffect(() => {
        if (!controlled) return

        if (visible) {
            setShouldRender(true)
            requestAnimationFrame(() => setAnimating(true))
        } else {
            setAnimating(false)
            const timer = setTimeout(() => setShouldRender(false), 250)
            return () => clearTimeout(timer)
        }
    }, [visible, controlled])

    if (!shouldRender) return null

    return (
        <div
            className={`area-loader-container ${className} ${
                controlled ? (animating ? 'area-loader--visible' : 'area-loader--hidden') : ''
            }`}
        >
            <div className="area-loader"></div>
            <p className="d-none">{text || 'Loading...'}</p>
        </div>
    )
}

export default Loader
